import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import {
	eSaleSetRegisterDichVuActionTypeIds,
	ISaleSetRegisterDichVuActionTypes
} from "../../action-types/dich-vu/ISaleSetRegisterDichVuActionTypes";
import { ISaleSetRegisterDichVuPageStateModel } from "../../page-state-model/dich-vu/ISaleSetRegisterDichVuPageState";

const initialState: ISaleSetRegisterDichVuPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	saleset_register_dichvus: [],
	saleset_register_dichvu_editing: undefined,
	saleset_register_dichvu_selected_ids: [],
	khoannop_groups_by_hocsinh: [],
	khoannop_groups_status: ePageBaseStatus.is_not_initialization,
	is_show_detail_modal: false
}

export const saleSetRegisterDichVuReducer = (state: ISaleSetRegisterDichVuPageStateModel = initialState, action: ISaleSetRegisterDichVuActionTypes): ISaleSetRegisterDichVuPageStateModel => {
	switch (action.type) {
		case eSaleSetRegisterDichVuActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eSaleSetRegisterDichVuActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				saleset_register_dichvus: action.payload
			}
		case eSaleSetRegisterDichVuActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				saleset_register_dichvus: []
			}
		case eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_START:
			return {
				...state,
				khoannop_groups_status: ePageBaseStatus.is_loading
			}
		case eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_SUCCESS:
			return {
				...state,
				khoannop_groups_status: ePageBaseStatus.is_completed,
				khoannop_groups_by_hocsinh: action.payload
			}
		case eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				khoannop_groups_status: ePageBaseStatus.is_completed,
				khoannop_groups_by_hocsinh: []
			}
		case eSaleSetRegisterDichVuActionTypeIds.CHANGE_KHOANNOP_BY_HOCSINH:
			return {
				...state,
				khoannop_groups_by_hocsinh: action.payload
			}
		case eSaleSetRegisterDichVuActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				saleset_register_dichvu_editing: action.payload,
				khoannop_groups_by_hocsinh: [],
				khoannop_groups_status: ePageBaseStatus.is_not_initialization
			}
		case eSaleSetRegisterDichVuActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				saleset_register_dichvu_editing: undefined,
				khoannop_groups_by_hocsinh: [],
				khoannop_groups_status: ePageBaseStatus.is_not_initialization
			}
		case eSaleSetRegisterDichVuActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				saleset_register_dichvu_selected_ids: action.payload
			}
		case eSaleSetRegisterDichVuActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eSaleSetRegisterDichVuActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Cập nhật thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				saleset_register_dichvu_editing: undefined,
				khoannop_groups_by_hocsinh: [],
				khoannop_groups_status: ePageBaseStatus.is_not_initialization
			}
		case eSaleSetRegisterDichVuActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
